<template>
  <div class="account edit">
    <breadcrumbs :subDomain="'Accounts'" :nestedLoc="['Profile']"></breadcrumbs>
    <h2>My Profile</h2>
    <notification v-if="notification" :notification.sync="notification"></notification>
    <div class="container">
      <div class="row">
        <div class="header--edit">
          <div class="tab active">
            Basic
          </div>
          <save @click.native.prevent="saveProfile()" :submitting.sync="submitting" :process="process"></save>
        </div>
      </div>
      <div class="tabContent tab1">
        <div class="row">
          <div class="formGroup col-5">
            <label for="first_name">
              First Name
            </label>
            <input type="text" id="first_name" v-model="customerMeta.given_name">
          </div>
          <div class="formGroup col-5">
            <label for="last_name">
              Last Name
            </label>
            <input type="text" id="last_name" v-model="customerMeta.family_name">
          </div>
          <div class="formGroup col-5">
            <label for="nickname">
              Nickname
            </label>
            <input type="text" id="nickname" v-model="customerMeta.nickname">
          </div>
        </div>
        <div class="row">
          <div class="formGroup col-6">
            <label for="email">
              Email
            </label>
            <input type="email" id="email" v-model="customerMeta.email">
          </div>
          <div class="formGroup col-6 offset-md-3">
            <label for="phone">
              Phone Number
            </label>
            <input type="tel" id="phone" v-model="customerMeta.phone_number">
          </div>
        </div>
        <hr />
        <addressComponent :address="customerMeta.address" v-model="customerMeta.address" :disabled="false" @update="customerMeta.address = $event"></addressComponent>

        <div class="row top-padded">
          <div class="formGroup col-5">
            <label for="password">
              Password
            </label>
            <router-link tag="button" :to="{ name: 'changePassword' }">Change Password</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Auth } from 'aws-amplify'
import { store } from '../store/index'
import notification from './notification'
// functions
import { notificationTrigger } from '../mixins/notification.js'

export default {
  name: 'Dashboard',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      process: 'Standard',
      submitting: false,
      userAuth: '',
      results: '',
      accessKeyId: '',
      secretAccessKey: '',
      sessionToken: '',
      instance: '',
      sig: '',
      customerMeta: {
        given_name: '',
        family_name: '',
        nickname: '',
        email: '',
        phone_number: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: ''
        }
      }
    }
  },
  mixins: [notificationTrigger],
  components: {
    'notification': notification
  },
  created: function () {
    this.initUser()
  },
  computed: {
  },
  methods: {
    async initUser () {
      await Auth.currentAuthenticatedUser({ bypassCache: true })
        .then(response => {
          this.$store.set('auth/load!', response, { root: true })
          let attrs = _.cloneDeep(response.attributes)
          this.customerMeta = Object.keys(attrs).reduce((metaObj, meta) => {
            if (this.isJSON(attrs[meta])) {
              attrs[meta] = JSON.parse(attrs[meta])
            }
            metaObj[meta] = attrs[meta]
            return metaObj
          }, {})
        })
    },

    async saveProfile () {
      this.submitting = true

      let addressString = JSON.stringify(this.customerMeta.address)
      let UserAttributes = {}
      for (var key in this.customerMeta) {
        if (this.customerMeta[key] !== undefined) {
          if (key === 'address') {
            UserAttributes['address'] = addressString
          } else {
            UserAttributes[key] = this.customerMeta[key]
          }
        }
      }
      await Auth.updateUserAttributes(store.state.user, UserAttributes).then(response => {
        store.set('loaded', this.customerMeta)
        this.savingAnimation('success', response)
        this.submitting = false
      }).catch(err => {
        console.log(err)
      })
      this.initUser()
    },

    isJSON (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .container {
  border: 1px solid;
}
.search{
  width: 100%;
  height: 100vh;
}
.square{
  height: 30px;
  width: 100%;
  background: #121212;
}
.top-padded{
 padding-top: 25px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/profile.vue